/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Send_PendingInputs */

const en_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const ar_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الإرسال…`)
};

const bn_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাঠানো হচ্ছে…`)
};

const de_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden…`)
};

const es_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const fr_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const pt_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const zh_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在发送...`)
};

const tr_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderiliyor…`)
};

const ru_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка…`)
};

const pl_form_send_pending = /** @type {(inputs: Form_Send_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłam…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Form_Send_PendingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_send_pending = /** @type {((inputs?: Form_Send_PendingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Send_PendingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_send_pending(inputs)
	if (locale === "bn") return bn_form_send_pending(inputs)
	if (locale === "de") return de_form_send_pending(inputs)
	if (locale === "es") return es_form_send_pending(inputs)
	if (locale === "fr") return fr_form_send_pending(inputs)
	if (locale === "pt") return pt_form_send_pending(inputs)
	if (locale === "zh") return zh_form_send_pending(inputs)
	if (locale === "tr") return tr_form_send_pending(inputs)
	if (locale === "ru") return ru_form_send_pending(inputs)
	if (locale === "pl") return pl_form_send_pending(inputs)
	return en_form_send_pending(inputs)
});